import { JobsFilterState } from './state';

export enum JobsActionType {
  CreateJob = 'CreateJob',
  UpdateJob = 'UpdateJob',
  PublishJob = 'PublishJob',
  ArchiveJob = 'ArchiveJob',
  SetSelectedJob = 'SetSelectedJob',
  SetSearchPhrase = 'SearchJobs',
  UpdateFilters = 'UpdateFilters',
  ResetFilters = 'ResetFilters',
  SetBackgroundLoading = 'SetBackgroundLoading',
  SetSearchLoading = 'SetSearchLoading',
}

export const setSearchPhrase = (searchPhrase: string) => ({
  type: JobsActionType.SetSearchPhrase as const,
  payload: { searchPhrase },
});

export const updateFilters = (filters: JobsFilterState) => ({
  type: JobsActionType.UpdateFilters as const,
  payload: { filters },
});

export const clearFilters = () => ({
  type: JobsActionType.ResetFilters as const,
});

export const setBackgroundLoading = (loading: boolean) => ({
  type: JobsActionType.SetBackgroundLoading as const,
  payload: { loading },
});

export const setSearchLoading = (loading: boolean) => ({
  type: JobsActionType.SetSearchLoading as const,
  payload: { loading },
});

export type JobsAction =
  | ReturnType<typeof setSearchPhrase>
  | ReturnType<typeof updateFilters>
  | ReturnType<typeof clearFilters>
  | ReturnType<typeof setBackgroundLoading>
  | ReturnType<typeof setSearchLoading>;
